// src/context/ZenithBlockContext.tsx
import type { ReactNode } from 'react'
import React, { createContext, useContext, useState } from 'react'

interface ZenithBlockContextType {
  budgetId: string
  setBudgetId: (id: string) => void
}

const ZenithBlockContext = createContext<ZenithBlockContextType | undefined>(undefined)

export const useZenithBlock = (): ZenithBlockContextType => {
  const context = useContext(ZenithBlockContext)
  if (!context) {
    throw new Error('ZenithBlock must be used within a ZenithBlockProvider')
  }
  return context
}

export const ZenithBlockProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [budgetId, setBudgetId] = useState<string>('')

  return <ZenithBlockContext.Provider value={{ budgetId, setBudgetId }}>{children}</ZenithBlockContext.Provider>
}
